// extracted by mini-css-extract-plugin
module.exports = {"container":"_1yGVSCcOj-I2t-F6Mbgik3","divider":"_1G_iFoC7jwNj6nAgYJYtOH"};